import type { ThemeConfig } from 'ant-design-vue/es/config-provider/context'

// Keep these values aligned with the portal palette and user-theme.css.
export const userTheme: ThemeConfig = {
  token: {
    colorPrimary: '#7357ff',
    colorInfo: '#7357ff',
    colorSuccess: '#159570',
    colorWarning: '#c68118',
    colorError: '#d9485f',
    colorText: '#171717',
    colorTextSecondary: '#626067',
    colorTextTertiary: '#85808b',
    colorTextQuaternary: '#aaa3b3',
    colorBgLayout: '#faf9f6',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    colorBorder: '#e4e1dc',
    colorBorderSecondary: '#ece8e2',
    colorFillAlter: '#f4f1ed',
    fontFamily: 'Manrope, "PingFang SC", "Microsoft YaHei", sans-serif',
    borderRadius: 10,
    borderRadiusLG: 20,
    controlHeight: 38,
    boxShadow: '0 12px 36px rgba(31, 24, 52, 0.12)',
    boxShadowSecondary: '0 14px 40px rgba(31, 24, 52, 0.08)',
  },
  components: {
    Button: { borderRadiusLG: 10 },
    Input: { borderRadiusLG: 10 },
    InputNumber: { borderRadiusLG: 10 },
    Select: { borderRadiusLG: 10 },
    DatePicker: { borderRadiusLG: 10 },
    Menu: {
      colorItemBg: '#faf9f6',
      colorSubItemBg: '#f4f1ed',
      colorItemText: '#626067',
      colorItemBgSelected: '#eeebff',
      colorItemTextSelected: '#6345ee',
      colorItemBgHover: '#f1efff',
      colorItemTextHover: '#171717',
      radiusItem: 10,
    },
    Table: { colorFillAlter: '#f4f1ed', colorFillContent: '#f7f5ff' },
    Modal: { fontSizeHeading5: 18 },
  },
}
